export default __webpack_public_path__ + "static/media/english-to-swedish-mobile-2.ea379166.png";